// extracted by mini-css-extract-plugin
module.exports = {"container":"DemoHeader_container__3Eojd","text":"DemoHeader_text__5z6vN","icon":"DemoHeader_icon__CZpci"};